import { render } from "./Sidebar.vue?vue&type=template&id=b233fb00&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=b233fb00&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=b233fb00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b233fb00"]])

export default __exports__